import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarChartComponent } from './bar-chart/bar-chart.component';
import { DonutChartComponent } from './donut-chart/donut-chart.component';
import { HeatMapComponent } from './heat-map/heat-map.component';
import { LineChartComponent } from './line-chart/line-chart.component';
import { NguiMapModule } from '@ngui/map';
import { ChartsModule as ng2ChartsModule } from 'ng2-charts';
import { MaterialModule } from '../../material.module';
import { RouterModule } from '@angular/router';
import { DoughnutChartComponent } from './doughnut-chart/doughnut-chart.component';

@NgModule({
	declarations: [
		BarChartComponent,
		DonutChartComponent,
		HeatMapComponent,
		LineChartComponent,
		DoughnutChartComponent,
	],
	imports: [
		CommonModule,
		NguiMapModule.forRoot({
			apiUrl:
				'https://maps.google.com/maps/api/js?key=AIzaSyDVO2M65l7mXKNWwbAoW64HJk2c7o1kQl8&libraries=visualization',
		}),
		ng2ChartsModule,
		MaterialModule,
		RouterModule,
	],
	exports: [
		BarChartComponent,
		DonutChartComponent,
		HeatMapComponent,
		LineChartComponent,
		DoughnutChartComponent,
	],
})
export class ChartsModule {}
